'use client';

import { Select, MenuItem } from '@mui/material';
import { useRouter } from '@/navigation';
import { TimePhase } from '@peerless/data-access/strapi';
import { useTranslations } from 'next-intl';

interface Props {
  timePhase: TimePhase;
}

export function TimePhaseDropdown({ timePhase }: Props) {
  const router = useRouter();
  const t = useTranslations();
  return (
    <Select
      defaultValue={timePhase}
      onChange={event => {
        if (!event.target.value) return;
        // Navigate to new URL based on selected year
        router.push(`/company/trade-shows?query=${event.target.value}`);
      }}
    >
      <MenuItem value={'upcoming'}>{t('Search.upcoming')}</MenuItem>
      <MenuItem value={'past'}>{t('Search.past')}</MenuItem>
    </Select>
  );
}
